import * as API from './apiBase';

let baseList = {
    GetRolesList: 'api/InvoiceNew/GetRolesList',
    CreateUpdRoles: 'api/InvoiceNew/CreateUpdRoles',
    DelRoleById: 'api/InvoiceNew/DelRoleById',
    GetRoleUsers: 'api/InvoiceNew/GetRoleUsers',
    SetRoleUsers: 'api/InvoiceNew/SetRoleUsers',
    GetRoleMenuList: 'api/InvoiceNew/GetRoleMenuList',
    SetRoleMenu: 'api/InvoiceNew/SetRoleMenu',
}

/*获取角色列表 */
export const GetRolesList = (searchCondition, language, PageIndex, PageSize) => {
    return API.POST(baseList.GetRolesList, {
        searchCondition,
        language,
        PageIndex,
        PageSize
    })
};

/*新增、编辑角色 */
export const CreateUpdRoles = (RoleId, RoleName, RoleEnName, Description, language) => {
    return API.POST(baseList.CreateUpdRoles, {
        RoleId,
        RoleName,
        RoleEnName,
        Description,
        language
    })
};

/*删除角色 */
export const DelRoleById = (roleId, language) => {
    return API.POST(baseList.DelRoleById, {
        roleId,
        language
    })
};

/*获取人员数据 */
export const GetRoleUsers = (RoleId, NoPsermissionContent, NoPermissionPageIndex, NoPermissionPageSize, PermissionContent, PermissionPageIndex, PermissionPageSize, language) => {
    return API.POST(baseList.GetRoleUsers, {
        RoleId,
        NoPsermissionContent,
        NoPermissionPageIndex,
        NoPermissionPageSize,
        PermissionContent,
        PermissionPageIndex,
        PermissionPageSize,
        language
    })
};

/*设置人员 */
export const SetRoleUsers = (RoleId, UserIds, Flag, language) => {
    return API.POST(baseList.SetRoleUsers, {
        RoleId,
        UserIds,
        Flag,
        language
    })
};

/*获取菜单数据 */
export const GetRoleMenuList = (RoleId, NoPsermissionContent, NoPermissionPageIndex, NoPermissionPageSize, PermissionContent, PermissionPageIndex, PermissionPageSize, language) => {
    return API.POST(baseList.GetRoleMenuList, {
        RoleId,
        NoPsermissionContent,
        NoPermissionPageIndex,
        NoPermissionPageSize,
        PermissionContent,
        PermissionPageIndex,
        PermissionPageSize,
        language
    })
};

/*设置菜单 */
export const SetRoleMenu = (RoleId, MenuIds, Flag, language) => {
    return API.POST(baseList.SetRoleMenu, {
        RoleId,
        MenuIds,
        Flag,
        language
    })
};
